export var SettingValueType;
(function (SettingValueType) {
    SettingValueType["BOOLEAN"] = "BOOLEAN";
    SettingValueType["NUMBER"] = "NUMBER";
    SettingValueType["STRING"] = "STRING";
    SettingValueType["LIST"] = "LIST";
    SettingValueType["MEDIA_ID"] = "MEDIA_ID";
    SettingValueType["JSON"] = "JSON";
    SettingValueType["CSS"] = "CSS";
    SettingValueType["CATEGORIES"] = "CATEGORIES";
    SettingValueType["HEX"] = "HEX";
    SettingValueType["SOCIAL_MEDIA"] = "SOCIAL_MEDIA";
})(SettingValueType || (SettingValueType = {}));
export const SettingValueTypeTranslation = {
    [SettingValueType.BOOLEAN]: 'Logiczny',
    [SettingValueType.NUMBER]: 'Liczba',
    [SettingValueType.STRING]: 'Tekst',
    [SettingValueType.LIST]: 'Lista',
    [SettingValueType.MEDIA_ID]: 'Media',
    [SettingValueType.JSON]: 'JSON',
    [SettingValueType.CSS]: 'CSS',
    [SettingValueType.CATEGORIES]: 'Lista kategorii',
    [SettingValueType.HEX]: 'Kolor',
    [SettingValueType.SOCIAL_MEDIA]: 'Social media'
};
//# sourceMappingURL=settingValueType.enum.js.map